module.exports = __webpack_public_path__ + "img/1450463293.215d1d88.jpg";